import { colors } from '@one-tree/library'
import styled from 'styled-components'

export const SimpleTable = styled.table`
  border: 1px solid ${colors.gray};
  border-collapse: separate;
  border-spacing: 0;
  th,
  td {
    padding: 5px 8px;
  }
  th {
    text-align: left;
    border-right: 1px solid ${colors.gray};
    border-bottom: 1px solid ${colors.gray};
    padding-bottom: 3px;
  }
  th:last-child {
    border-right: none;
  }
  td {
    font-size: 0.9rem;
    line-height: 1.2rem;
    vertical-align: middle;
  }
  tr:nth-child(even) {
    background-color: ${colors.lightGray};
  }
`
